import { createSvgIcon } from '@mui/material';

const ScoreConfigIcon = (props) => {
  const IconCmp = createSvgIcon(
    <>
      <rect
        y="0.220703"
        width="62"
        height="62"
        rx="31"
        fill="url(#paint0_linear_31_23266)"
        fill-opacity="0.12"
      />
      <path
        d="M43.5 31.2207C43.5 38.1243 37.9036 43.7207 31 43.7207C24.0964 43.7207 18.5 38.1243 18.5 31.2207M43.5 31.2207C43.5 24.3171 37.9036 18.7207 31 18.7207M43.5 31.2207H40.375M18.5 31.2207C18.5 24.3171 24.0964 18.7207 31 18.7207M18.5 31.2207H21.625M31 18.7207V21.8457M39.848 22.4707L32.8749 29.3457M39.848 40.0687L39.5932 39.8139C38.7284 38.9491 38.296 38.5167 37.7914 38.2075C37.3441 37.9334 36.8563 37.7313 36.3462 37.6089C35.7707 37.4707 35.1592 37.4707 33.9363 37.4707L28.0637 37.4707C26.8407 37.4708 26.2293 37.4708 25.6538 37.6089C25.1437 37.7314 24.6559 37.9334 24.2086 38.2076C23.704 38.5168 23.2716 38.9491 22.4069 39.8139L22.152 40.0687M22.152 22.4707L24.3226 24.6413M33.5 31.2207C33.5 32.6014 32.3807 33.7207 31 33.7207C29.6193 33.7207 28.5 32.6014 28.5 31.2207C28.5 29.84 29.6193 28.7207 31 28.7207C32.3807 28.7207 33.5 29.84 33.5 31.2207Z"
        stroke="url(#paint1_linear_31_23266)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_31_23266"
          x1="0"
          y1="31.2207"
          x2="62"
          y2="31.2207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00D2FF" />
          <stop offset="1" stop-color="#3A7BD5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_31_23266"
          x1="18.5"
          y1="31.2207"
          x2="43.5"
          y2="31.2207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#10ADCF" />
          <stop offset="1" stop-color="#3A7BD5" />
        </linearGradient>
      </defs>
    </>,
    'ScoreConfigIcon',
  );
  return (
    <IconCmp
      width="62"
      height="63"
      viewBox="0 0 62 63"
      style={{
        fill: 'none',
      }}
      {...props}
    />
  );
};
export default ScoreConfigIcon;
